import script from "./novoProjetoEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./novoProjetoEdit.vue?vue&type=script&setup=true&lang=js"

import "./novoProjetoEdit.vue?vue&type=style&index=0&id=5fd1d9ab&lang=css"

const __exports__ = script;

export default __exports__